import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  planWizardFormDefaultValues,
  planWizardFormSchema,
  IPlanWizardFormModel,
} from "../models/planWizardFormModel";
import { useAppContext } from "../../../../../AppContext";
import { useEffect } from "react";
import { PlanDurationMetric } from "../../../../../common/enums";
import { useParams } from "react-router-dom";
import { useFormValidationMessages } from "../../../../../common/infrastructure/hooks/useFormHelper";
import { IIPlanWizardInitialDataViewModel } from "../models/planWizardInitialDataViewModel";

export const usePlanWizardForm = (
  wizardInitialData?: IIPlanWizardInitialDataViewModel
) => {
  const { id } = useParams();
  const { selectedStudioId } = useAppContext();

  const form = useForm<IPlanWizardFormModel>({
    defaultValues: planWizardFormDefaultValues,
    resolver: yupResolver(planWizardFormSchema),
  });

  useEffect(() => {
    form.setValue("durationMetric", PlanDurationMetric.Days);
    form.setValue("studioId", selectedStudioId);
    if (id) {
      form.setValue("id", Number(id));
    }

    if (wizardInitialData && wizardInitialData.currentlySelectedPlan) {
      form.setValue("name", wizardInitialData.currentlySelectedPlan.name);
      form.setValue(
        "numberOfVisits",
        wizardInitialData.currentlySelectedPlan.numberOfVisits
      );
      form.setValue(
        "isUnlimitedVisits",
        wizardInitialData.currentlySelectedPlan.isUnlimitedVisits
      );
      form.setValue(
        "durationNumber",
        wizardInitialData.currentlySelectedPlan.durationNumber
      );
      form.setValue(
        "durationMetric",
        wizardInitialData.currentlySelectedPlan.durationMetric
      );
      form.setValue("price", wizardInitialData.currentlySelectedPlan.price);
      form.setValue(
        "studioPlanTypeId",
        wizardInitialData.currentlySelectedPlan.studioPlanTypeId
      );
      form.setValue(
        "consumerTypeId",
        wizardInitialData.currentlySelectedPlan.consumerTypeId
      );
    }
  }, [selectedStudioId, wizardInitialData]);

  useFormValidationMessages<IPlanWizardFormModel>(form);

  return form;
};
